import { observer } from 'mobx-react-lite'
import { FilterControlsToggleButton } from '@/components/FilterControlsToggleButton'
import { useToggle } from '@/hooks/state-hooks'
import { FilterControlsContainer } from '@/components/FilterControls/FilterControlsContainer'
import {
  TableSearchbar,
  TableSearchbarMenuItem,
} from '@/components/TableSearchbar'
import { type UserManagementViewModel } from '@/features/user-management/UserManagement/UserManagementViewModel'
import { UserManagementTableMenuContainer } from '@/features/user-management/components/UserManagementTableMenu/UserManagementTableMenuContainer'

export interface UserManagementTableControlsContainerProps {
  vm: UserManagementViewModel
}

export const UserManagementTableControlsContainer = observer(
  function UserManagementTableControlsContainer({
    vm,
  }: UserManagementTableControlsContainerProps) {
    const userSearchVm = vm.userSearch
    const hasFilters = userSearchVm.filters.appliedFilterCount > 0
    const showingFilterControls = useToggle(hasFilters)

    return (
      <>
        <TableSearchbar
          isDisabled={false}
          searchText={userSearchVm.searchText.value}
          onSearchTextChange={userSearchVm.searchText.change}
        >
          <TableSearchbarMenuItem>
            <FilterControlsToggleButton
              active={showingFilterControls.isEnabled}
              count={userSearchVm.filters.appliedFilterCount}
              onPress={showingFilterControls.toggle}
            />
          </TableSearchbarMenuItem>

          <TableSearchbarMenuItem>
            <UserManagementTableMenuContainer vm={vm} />
          </TableSearchbarMenuItem>
        </TableSearchbar>

        <FilterControlsContainer
          active={showingFilterControls.isEnabled}
          vm={userSearchVm.filters}
          editorTestId="job"
          testId="job-filter"
        />
      </>
    )
  },
)
